export default "__VITE_ASSET__c2224542__"